import styled from 'styled-components';

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: baseline;
    align-content: center;
    h1 {
        margin-bottom: 0;
    }
    .title {
        flex-grow: 1;
    }
    .button {
        flex-grow: 0;
        flex-basis: 148px;
    }

    div.sync-data {
        transform: translateY(-10px);
        p {
            font-size: 12px;
            line-height: 6px;
            color: gray;
        }
    }
`;

export const SearchRow = styled.div`
    margin: 0 0 16px;
`;
